import { IconRegister } from 'modules/common/icons';
import { Button } from 'modules/common/input';
import { showModal } from 'modules/common/modal';
import landingBG from 'assets/images/illustrations/landing-bg.svg';
import React from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import PageTitle from 'modules/common/components/PageTitle';
import AppBrand from './Brand';
import AppFooter from './Footer';

function Landing() {
  const { state } = useLocation();
  const is_new_registerd = !!state?.is_new_registerd;
  const history = useHistory();

  React.useEffect(() => {
    if (is_new_registerd) {
      showModal({
        title: false,
        noClose: true,
        modalSize: 'modal-sm',
        content: (onClose) => {
          const handleOnClose = (e) => {
            e.preventDefault();
            onClose();
            history.replace({ state: '' });
            sessionStorage.clear();
          };
          return (
            <div className="flex flex-col justify-center text-center">
              <div className="flex justify-center">
                <IconRegister />
              </div>
              <p className="text-xl font-medium text-primary-500 mt-4 mb-8">
                You are successfully registered.
              </p>
              <div className="flex justify-center">
                <Button
                  onClick={handleOnClose}
                  className="btn primary md w-96"
                  label="Done"
                />
              </div>
            </div>
          );
        },
      });
    }
  }, [history, is_new_registerd]);

  return (
    <>
      <PageTitle title="Manila E-Citizen" />
      <div className="px-10 sm:px-24 h-full w-full bg-index relative">
        <div className="grid grid-cols-1 lg:grid-cols-2 h-full relative z-10">
          <div className="col-span-1 my-auto">
            <AppBrand className="lg:h-28 w-auto" />
            <div className="my-12 2xl:my-32">
              <h4 className="text-center sm:text-left text-4xl lg:text-7xl text-primary-500 font-bold my-12">
                Manila Resident’s <br /> ID Portal
              </h4>
              <div className="flex align-center z-0 sm:hidden mt-10">
                <img src={landingBG} alt="Landing Main Background" />
              </div>
              <p className="text-3xl text-gray-600 font-semibold text-center sm:text-left my-6 md:my-12">
                Apply now for a Resident’s ID
              </p>
              <div className="flex flex-col md:flex-row items-center">
                <Link
                  to="/login"
                  className="btn md 2xl:lg primary w-64 md:mr-2 my-1"
                >
                  Login
                </Link>
                <Link
                  to="/register"
                  className="btn md 2xl:lg outline-primary w-64 md:ml-2 my-1"
                >
                  Register Now
                </Link>
              </div>
            </div>
            <AppFooter />
          </div>
          <div className="sm:flex align-center z-0 hidden">
            <img src={landingBG} alt="Landing Main Background" />
          </div>
        </div>
      </div>
    </>
  );
}

Landing.propTypes = {};

export default Landing;
